import { SettingsSidebar } from "@/components/settings/SettingsSidebar";
import { useWorkspaceStore } from "@/lib/workspace";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/settings")({
	component: SettingsLayout,
});

function SettingsLayout() {
	const fetchWorkspaces = useWorkspaceStore((s) => s.fetchWorkspaces);
	useEffect(() => {
		fetchWorkspaces();
	}, [fetchWorkspaces]);

	return (
		<div className="flex h-full">
			<SettingsSidebar />
			<div className="flex-1 overflow-y-auto min-w-0">
				<div className="px-6 pt-4 pb-6">
					<Outlet />
				</div>
			</div>
		</div>
	);
}
